import { WithdrawState, WithdrawResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getWithdrawHistories } from './withdraw.services';

export const initialState: WithdrawState = {
    data: {} as WithdrawResponse,
    status: "loading",
    error: {}
}

export const WithdrawSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getWithdrawHistories.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getWithdrawHistories.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getWithdrawHistories.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const WithdrawReducer = WithdrawSlice.reducer